import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { FlowSteps, PageHeader, RegistrationForm } from "../components";
import { useRoutes } from "../hooks/use-routes";
import { safeTrackEvent, signUpViewEvent } from "../tracking/events";

export const Registration = () => {
  const { t } = useTranslation();
  const { goToPhoneVerification } = useRoutes();

  useEffectOnce(() => {
    safeTrackEvent(() => signUpViewEvent(), "sign_up_view", "registration mount");
  });

  return (
    <IntersectionFadeIn className="mx-auto w-full max-w-[1275px] px-4 pt-8 pb-14 md:px-8 md:pb-20 lg:px-12">
      <FlowSteps />
      <PageHeader
        header={`${t("GROUP_ACTIONS_ORDERING.GENERAL.ADD_PERSONAL_DETAILS")}`}
        onBack={goToPhoneVerification}
      />
      <RegistrationForm />
    </IntersectionFadeIn>
  );
};
